import { render, staticRenderFns } from "./water-form.html?vue&type=template&id=8661ba78&scoped=true&external"
import script from "./water-form.js?vue&type=script&lang=js&external"
export * from "./water-form.js?vue&type=script&lang=js&external"
import style0 from "./water-form.scss?vue&type=style&index=0&id=8661ba78&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8661ba78",
  null
  
)

export default component.exports